import EventBus from 'eventing-bus';
import Store from 'store2';
import IMDB from './imdb';
import {serialize as Serializer} from 'dom-form-serializer';
import {Instance as AWS} from './aws';
import {Post, Dispatch} from './utils';
import Alpine from 'alpinejs';
import $ from 'jquery';


const store = Store.namespace('imdb');
const mediaStore = Store.namespace('media');
const clearStore = function() {
    mediaStore.remove('completed_files');
    store.remove('imdb_details');
    store.remove('imdb_cast');
    store.remove('imdb_producers');
    store.remove('imdb_writers');
    store.remove('imdb_media_videos');
    store.remove('imdb_media_images');
    store.remove('imdb_loading');
    store.remove('selected');

    store.remove('form_response');
    store.remove('form_errors');
    store.remove('form_submitted_successfully');
    store.remove('form_complete');
    store.remove('step');
};

if (store.get('form_submitted_successfully')) {
    clearStore();
}

window.imdb_store = store

async function AddFile(n, file) {
    console.log('Adding file', n, file);

    let i = 9999999;
    let id = `${Math.round(Math.random() * i)}-${Math.round(Math.random() * i)}`;
    let preview;
    let psd;

    let data = {
        id,
        filename: file.name,
        filesize: file.size,
        status: "Processing",
        css_status: 'processing',
        file: file,
        path: `${n}/${current_user.id || 0}/${id}/${file.name}`,
        type: n,
        preview,
        progress: 0
    };

    Alpine.store('media').addFile(data);

    try {
        if (file.name.indexOf('.psd') >= 0) {
            //
        } else {
            preview = URL.createObjectURL(file.file || file);
            console.log('prevew created from file image');
        }

        data.preview = preview
        Alpine.store('media').updateFile(data);

    } catch(e) {
        console.error("preview generation failed", e);
    }

    data.status = "Uploading";
    data.css_status = "uploading";
    Alpine.store('media').updateFile(data);

    await AWS.puts(data)
};

async function ChoseFile(e) {
    let selected = e.target.files
    if (!selected || selected.length === 0) { return; }
    let ftype = $(e.target).attr('id').split('-')[0];
    console.log('chosen file', ftype, selected);

    for (let f of selected) {
        await AddFile(ftype, f);
    }


    e.target.value = null;
}

function RemoveFile(f) {
    if (confirm(`Remove ${f.type} ${f.filename || f} ?`)) {
        console.log('removing file', f, f.type);
        Alpine.store('media').removeFile(f);
    }
}

function SelectFileDialog(t) {
    console.log('Selecting file', t);
    $(`#${t}-file-picker`).trigger('click');
}


export function AppData(){
    let imdb = store.get('selected');
    let details = store.get('imdb_details');
    let cast = store.get('imdb_cast') || [];
    let writers = store.get('imdb_writers') || [];
    let directors = store.get('imdb_directors') || [];

    let details_loaded = details && true || false;
    if (!details_loaded) {
        details = {};
    }
    let url_step
    try {
        url_step = parseInt(window.location.hash.split('#step/')[1])
    } catch (e) {
        url_step = null
    }

    console.log('url_step', url_step);

    let saved_step = url_step || 1;
    let ferrors = []; //store.get('form_errors');
    let fsubmitted = store.get('form_submitted_successfully');
    let form_response = store.get('form_response');
    let form_complete = store.get('form_complete');
    let specs = {
        poster: { w: 900, h: 1285 },
        landscape: { w: 896, h: 504 },
        hero: { w: 1920, h: 1080 },
        videos: { w: 1920, h: 1080 },
    };

    let files = Alpine.store('media');
    let summary_details = store.get('summary_details') || [];

    let app_data = {
        patch: function(payloadOrEvent){
            console.log('Patching', payloadOrEvent);
            if(payloadOrEvent instanceof CustomEvent){
                for(const key in payloadOrEvent.detail){
                    this[key] = payloadOrEvent.detail[key];
                }
            }else{
                window.dispatchEvent(new CustomEvent("patch", {
                    detail: payloadOrEvent
                }));
            }
        },

        show_imdb_cast: false,

        summary_details,
        media_posters: [],
        media_landscapes: [],
        media_heros: [],
        media_trailers: [],
        media_images: [],

        valid_uploads: true,
        step: 1,
        form_complete: form_complete,
        form_response: form_response,
        form_errors: ferrors,
        form_submitted_successfully: fsubmitted,

        poster_photos_count: files.posters.length,
        landscape_photos_count: files.landscapes.length,
        hero_photos_count: files.heros.length,

        max_posters: 3,
        max_landscapes: 3,
        max_heros: 10,
        max_videos: 3,
        max_subtitles: 10,
        max_trailers: 3,
        max_images: 10,

        specs,
        spec_dimensions: (t)=> (`${specs[t].w}x${specs[t].h}`),
        add_file: AddFile,
        select_file: SelectFileDialog,
        remove_file: RemoveFile,
        chose_file: ChoseFile,
        files,

        imdb,
        imdb_writers: writers,
        imdb_directors: directors,
        imdb_cast: cast,
        imdb_details: details,
        imdb_details_loaded: details_loaded,
        imdb_loading: false,
        imdb_media_loading: false,
        imdb_media_loaded: false,
        imdb_media_import_button: 'Scan IMDB',
        imdb_media_images: [],
        imdb_media_videos: [],

        selected_images: {},
        selected_videos: {},

        check_video_selected: function(id) {
            return this.selected_videos[id] && true;
        },

        check_image_selected: function(id) {
            return false;
            return this.selected_images[id] && true;
        },

        select_image: function(id) {
            console.log('selecting image', id)
            this.selected_images[id] = true;
        },

        unselect_image: function(id) {
            console.log('unselecting image', id)
            this.selected_images[id] = false;
            delete this.selected_images[id];
        },

        select_video: function(id) {
            console.log('selecting video', id)
            this.selected_videos[id] = true;
        },

        select_all_videos: function() {
            let all = {};
            for (let video of this.imdb_media_videos) {
                all[video.k] = true;
            }

            return all
        },

        select_all_images: function() {
            let all = {};
            for (let img of this.imdb_media_images) {
                all[img.k] = true;
            }

            return all
        },

        imdb_media_fetch: async function(){
            console.log('[imdb] media fetching')
            this.imdb_media_loading = true;
            this.imdb_media_import_button = "Scanning IMDB.."
            let id = this.imdb && this.imdb.id
            if (!id) {
                return;
            }
            let images = [];
            let videos = [];

            try {
                images = await (await fetch(`/imdb/images/${id}`)).json();
                console.log('received images', images)
                let selected_images = this.selected_images
                this.imdb_media_images = images.map((img)=>{
                    if (window.btoa) {
                        img.k = btoa(img.large);
                    } else {
                        img.k = img.large;
                    }

                    selected_images[img.k] = true;
                    return img;
                });
            } catch (e) {
                console.error("[imdb] failed fetching images", e)
            }
            try {
                let request = await fetch(`/imdb/videos/${id}`)
                videos = await request.json();

                if (!videos || videos.error || !videos.map)  {
                    console.error('Video Fetch Error', videos.error || videos)
                    throw new Error(videos.error || "Invalid Video from Request")
                }

                console.log('videos', videos)
                videos = videos.map((video)=> {
                    if (window.btoa) {
                        video.k = btoa(video.mp4)
                    } else {
                        video.k = video.mp4
                    }

                    this.selected_videos[video.k] = true;
                    return video;
                });

                console.log('received videos', videos)
                this.imdb_media_videos = videos;
            } catch (e) {
                console.error("[imdb] failed fetching videos", e)
            }

            this.imdb_media_loading = false;
            this.imdb_media_import_button = "Scan IMDB Again"
        },

        show_add_file: function(typ) {
            let media = Alpine.store('media');
            let data = media[typ]();

            if (data && data.length < 3){
                return true;
            }
        },

        alert_next_button_pending: function(){
            let s = parseInt(this.step || 1);
            if (s === 5) {
                alert("Upload at least 1 image per category");
            }

        },

        show_next_button: false,
        update_show_next_button: function() {
            let s = parseInt(this.step || 1);

            if (s < 6 && s > 1) {
                if (s === 5) {
                    if (this.poster_photos_count > 0 && this.landscape_photos_count > 0 && this.hero_photos_count > 0) {
                        this.show_next_button = true;
                        return true;
                    }
                } else {
                    this.show_next_button = true;
                    return true;
                }
            }

            this.show_next_button = false;
        },

        form_error_html: function () {
            return this.form_errors.join('<br/>');
        },

        form_retry: function () {
            console.log('[app] retrying form details');
            this.step = 1;
            this.form_errors = false;
            this.form_response = false;
        },

        complete_form: async function (opts) {
            let start = parseFloat(new Date().getTime() / 1000);
            console.log('[app] complete_form started', start);

            let data = Serializer($('form#new_content')[0]);
            let s3_files = Alpine.store('media').completed_files.map((f)=>(f.s3_file_id));
            data.s3_files = s3_files;
            data.imdb_media_images = this.imdb_media_images.filter((img)=>(this.selected_images[img.k])).map((img)=>(img.large));
            data.imdb_media_videos = this.imdb_media_videos.filter((v)=>(this.selected_videos[v.k])).map((v)=>({ mp4: v.mp4, url: v.url, image: v.image}));

            if (this.imdb_details) {
                data.cover_url = this.imdb_details.image
            }

            data.imdb_cast = this.imdb_cast
            data.imdb_writers = this.imdb_writers
            data.imdb_directors = this.imdb_directors

            data.gross_north_america = this.imdb_details.gross_north_america
            data.gross_worldwide = this.imdb_details.gross_worldwide
            if (!data.country_of_origin) {
                data.country_of_origin = this.imdb_details.country_of_origin
            }

            if (!data.keywords) {
                data.keywords = this.imdb_details.keywords
            }

            if (!data.release_date) {
                data.release_date = this.imdb_details.release_date
            }

            if (this.imdb_details.is_movie) {
                data.is_movie = true
            }


            console.log('data.imdb_media_images', data.imdb_media_images)
            console.log('data.imdb_media_videos', data.imdb_media_videos)
            data.additional_image_links = this.additional_image_links || []

            let url = '/listings/submit_form';
            let imdb = store.get('selected');
            if (!data.content.imdb_id && imdb && imdb.id && imdb.id.length > 1) {
                data.content.imdb_id = imdb.id;
                data.imdb_id = imdb.id;
            }

            let json = {};
            let valid = true;
            let errors = [];

            if (!data.title || data.title.length < 1) {
                errors.push('Invalid Film Title');
            }

            if (valid) {
                json = await Post(url, data) || {};
            } else {
                json = { errors };
            }

            this.form_response = json;
            store.set('form_response', json);
            console.debug('[app] form_response', json);

            if (json.errors && json.errors.length > 0) {
                console.error("[app] Form Errors", json.errors);
                store.set('form_errors', json.errors);
                this.form_errors = json.errors;
            }

            if (json.success) {
                this.form_errors = false;
                store.set('form_errors', null);

                this.form_submitted_successfully = true;
                store.set('form_submitted_successfully', true);
                if (json.content && json.content.id) {
                    try {
                        $('.app-container').removeClass('opacity-100');
                        $('.app-container-loading').addClass('opacity-100');
                        this.clear();
                        clearStore();
                    } catch (e) {
                        console.error(e);
                    }
                    let url = `/listings/l/${json.content.id}`;
                    window.custom_navigation(url)
                }
            }

            let end = parseFloat(new Date().getTime() / 1000);
            console.log(`[app] complete_form: finished: ${parseFloat(end - start)}`, { start, end });
        },

        imdb_update: function (data) {
            let selected = data && data.details || store.get('selected');

            if (selected && selected !== "undefined" && selected.id) {
                this.imdb = selected;
            } else {
                this.imdb = null;
            }

            if (this.imdb && this.imdb.id) {
                let data = IMDB.detailsFor(this.imdb.id);
                let details = data && data.details
                let cast = data && data.cast
                let writers = data && data.writers
                let directors = data && data.directors

                if (cast) {
                    if (cast.cast) {
                        cast = cast.cast
                    }
                    this.imdb_cast = cast;
                    store.set('imdb_cast', cast);
                    console.log('cast set', cast)
                }

                if (writers) {
                    this.imdb_writers = writers
                    store.set('imdb_writers', writers)
                    console.log('writers set', writers)
                }

                if (directors) {
                    this.imdb_directors = directors;
                    store.set('imdb_directors', directors)
                    console.log('directors set', directors)
                }

                if (details && details.id) {
                    this.imdb_details = details;
                    store.set('imdb_details', details);
                    this.imdb_details_loaded = true;
                } else {
                    this.imdb_details = false;
                    this.imdb_details_loaded = false;
                }

                if (this.imdb_details) {
                    this.imdb_loading = false;
                    let rating = this.imdb_details.contentRating
                    let genres = this.imdb_details.genres
                    if (rating && rating.length > 0) {
                        let val = rating
                        if (rating.indexOf('13') >= 0) {
                            val = 'PG-13'
                        } else if (rating.indexOf('14') >= 0) {
                            val = 'TV-14'
                        } else {
                            val = 'G'
                        }

                        let q = `#content_rating option[value='${val}']`
                        console.log('Setting contentRating', q)
                        $(q).attr('selected', true)
                    }

                    let set_feature = 'Feature'
                    let title = this.imdb_details.title && this.imdb_details.title.toLowerCase() || '';

                    if (rating && rating.indexOf('TV') >= 0) {
                        $(`#content_type_of_project option[value='Series']`).attr('selected', true)
                        set_feature = 'Series'
                    }

                    if (genres.indexOf('documentary') >= 0) {
                        set_feature = 'Documentary'
                    } else if (genres.indexOf('short') >= 0) {
                        set_feature = 'Short'
                    } else if (title.indexOf('(short)') >= 0) {
                        set_feature = 'Short'
                    } else if (title.indexOf('(documentary)') >= 0) {
                        set_feature = 'Documentary'
                    }

                    if (set_feature) {
                        $(`#content_type_of_project option[value='${set_feature}']`).attr('selected', true)
                    }

                } else {
                    this.imdb_loading = true;
                }
            }

            const debug = {
                imdb: this.imdb,
                imdb_loading: this.imdb_loading,
                imdb_details: this.imdb_details,
                selected
            };

            console.log('[app] update notice received', debug);
        },

        clear: function () {
            console.log('[app] removing selected');
            EventBus.publish('imdb-clear');
            store.remove('selected');

            this.imdb = null;
            this.imdb_details = false;
            this.imdb_loading = false;
            this.form_response = null;
            this.form_errors = null;
            this.form_submitted_successfully = false;
            this.step = 1;
            clearStore();
        },

        refresh: function () {
            console.log('[app] refreshing');
            let updated = this._data();
            for (let k of updated) {
                console.log(`[app] refreshing -> ${k}`, k, updated);
            }
        },
        next: function(){ this.next_step(); },
        next_step: function () {
            console.log('[app] next step');
            this.step = this.step + 1;
            store.set('step', this.step);
            window.location.hash = `step/${this.step}`;
            window.scrollTo(0,0);
            this.hooks(this.step);

            return this.step;
        },

        skip_autofill: function() {
            console.log('skip_autofill')
            this.step = (this.step || 0) + 2;
            store.set('step', this.step);
            return this.step;
        },


        previous_step: function () {
            console.log('[app] previous step');
            let t = this.step - 1;

            if (t == 2) {
                this.step = 1;
            } else {
                this.step = t
            }

            store.set('step', this.step);
            window.location.hash = `step/${this.step}`;
            return this.step;
        },

        file_update_result: null,
        file_update_event: function(evt){
            let detail = evt.detail || evt.target || evt;
            this.validate_uploads_event();
            return detail;

        },

        validate_uploads_event: function() {
            let media = Alpine.store('media');
            let valid = true;

            //if (media.posters[0] && media.heros[0] && media.landscapes[0]) {
            //    valid = true;
            //}

            console.log('[app] valid_uploads', valid, media);
            this.valid_uploads = valid;
        },

        setup_summary_data: function() {
            console.log('Setup Summary Data');
            let new_data = [];

            let data = Serializer($('form#new_content')[0])['content'];
            let keys = Object.keys(data);
            let s3_files = Alpine.store('media').completed_files.map((f)=>(f.s3_file_id));
            data.s3_files = s3_files;

            for (let d of keys) {
                new_data.push({ k: d, v: data[d] });
            }

            this.summary_details = new_data;
            store.set('summary_details', new_data);
            console.log('summary_data', this.summary_details, data);
            return new_data;
        },

        hooks: function() {
            let s = this.step;
            this.setup_summary_data();

            switch(s) {
            case 1:
                break;
            case 7:
                this.setup_summary_data();
                break;
            }
        }
    };

    console.log('app_data', app_data);
    window.app = app_data
    return app_data;
}

export default AppData;
